import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import LegalPage from "./components/LegalPage";
import { I18nProvider } from "./i18n";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container);

// Simple path-based routing for standalone pages
const path = window.location.pathname;

const LEGAL_ROUTES = {
  "/privacidad": "privacidad",
  "/privacy": "privacy",
  "/aviso-legal": "aviso",
  "/cookies": "cookies",
  "/condiciones": "condiciones",
};

let page;
if (LEGAL_ROUTES[path]) {
  page = <LegalPage type={LEGAL_ROUTES[path]} />;
} else {
  page = <App />;
}

root.render(
  <React.StrictMode>
    <I18nProvider>
      {page}
    </I18nProvider>
  </React.StrictMode>
);
